import { useSbkBetSlipStore } from '@/feature/betslip-sbk/hooks/use-sbk-betslip-store';
import { useMarketName } from '@/feature/event-details-sbk/hooks/use-market-name';
import { useShallow } from 'zustand/react/shallow';

export const EMPTY_MARKET_TYPE = { code: '', params: {} } as const;
const EMPTY_TEAM = {} as const;

/**
 * Hook to get the market name for all bet slip components
 */
export const useBetSlipMarketName = ({ marketId, eventId }: { marketId: string; eventId: string }) => {
    const { homeTeam, awayTeam, ...rest } = useSbkBetSlipStore(
        useShallow(state => {
            const market = state.markets[marketId];
            return {
                sportName: state.events[eventId]?.sport?.name,
                homeTeam: state.events[eventId]?.home_team ?? EMPTY_TEAM,
                awayTeam: state.events[eventId]?.away_team ?? EMPTY_TEAM,
                player: market?.player,
                fallback: market?.description,
                marketType: market?.marketType ?? EMPTY_MARKET_TYPE,
                appendTeamName: !market?.isMicroMarket,
                appendPlayerName: true,
                appendMicroMarketDescription: market?.isMicroMarket,
                isExtendedName: true,
            };
        })
    );
    return useMarketName({
        ...rest,
        event: { home_team: homeTeam, away_team: awayTeam },
    });
};
